import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form } from "antd";
import { InputField } from "../../../../../../../CommonComponents/commonStyles";
import PropTypes from "prop-types";
import {
  WrapLabel,
  LabelWrapper,
  InputWrapper,
  InputWrapperGraded,
  PlaceholderWrap,
  InfoMessage
} from "./styles";
import { Rules } from "../Rules/Rules";
import { changeFundDetails, checkVGMutualFund,updateContributionStatus, updateAutoFilledStatus, updateErrorMessage } from "../../../actions";
import TooltipComponent from "../../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
let isEdit = false;
let data = "";
let l10nUSD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })

class FundDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {currentValue : this.props.value}
    this.onTextChange = this.onTextChange.bind(this);
  }

  componentWillReceiveProps (nextProps){
    if(( this.props.property === "fundNumber" || this.props.property === "fundName" || this.props.property === "tickerSymbol") && nextProps.assetHeld === "assetHeldatVG" && nextProps.isAutoFilled){
    let id = this.props.accountId.toString() + this.props.assetHeld + this.props.contributionType + this.props.inputId.toString() + this.props.property;
    let value = {};
    value[id] =  nextProps.value;
    this.setState({currentValue: nextProps.value});
    this.props.form.setFieldsValue(value);
    this.props.form.validateFields();
    this.props.property === 'fundName' && this.props.updateAutoFilledStatus();
    }
    if( this.props.property === 'numberofShares' && (this.props.allShare !== nextProps.allShare) && nextProps.allShare){
      let id = this.props.accountId.toString() + this.props.assetHeld + this.props.contributionType + this.props.inputId.toString() + this.props.property;
      let value = {};
      value[id] =  '0';
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
      this.props.updateAutoFilledStatus();
    }
    if(this.props.assetHeld === nextProps.showErrorMessage.assetHeld && nextProps.showErrorMessage.fund){
        let id = this.props.accountId.toString() + this.props.assetHeld + this.props.contributionType + this.props.inputId.toString() + this.props.property;
        let value = {};
        value[id] =  this.props.value;
        this.props.form.setFieldsValue(value);
      this.props.form.validateFields(); 
      if((this.props.accountId+1) === this.props.accountInfo.length && ((this.props.inputId + 1) === this.props.accountInfo[this.props.accountInfo.length-1].fundInformation.length) && this.props.property === 'numberofShares'){
        if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected))
        this.props.updateErrorMessages({type: 'fund'});
      }
      if((this.props.accountId + 1) === this.props.accountInfo.length && this.props.accountInfo[this.props.accountInfo.length-1].type === 'Select Account Type'){
        if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected)){
          this.props.updateErrorMessages({type: 'dropDown'});
          this.props.updateErrorMessages({type: 'inputDropDown'});
          this.props.updateErrorMessages({type: 'addressInput'});
          this.props.updateErrorMessages({type: 'inputComponent'});
        }
      }
    } else if(nextProps.isCleared !== this.props.isCleared && nextProps.isCleared){
      let id = this.props.accountId.toString() + this.props.assetHeld + this.props.contributionType + this.props.inputId.toString() + this.props.property;
      let value = {};
      value[id] =  '11';
      this.props.form.setFieldsValue(value);
      this.props.form.validateFields();
  }
    if(nextProps.value !== this.props.value){
      this.setState({currentValue: nextProps.value})
    }
 }

 onFocus = () => {
   if(this.props.property === 'numberofShares'){
      isEdit = true;
      this.setState({value: true});
   }
}

onFocusOut= (e) =>{
  if(this.props.property === 'numberofShares' && !this.props.allShare){
      isEdit = false;
      let value = e.target.value ? parseFloat(
        e.target.value
      ).toLocaleString(undefined, {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4
      }) : '';     
      (this.props.value !== value) && (this.props.updateValue(value));
  } else {
    (e.target.value !== this.props.value) && (this.props.updateValue(e.target.value));
  }
  if(this.props.assetHeld === 'stockCertificate' && !this.props.isStockSelected){
    if(this.props.contribTypeStatus === null)  this.props.updateContributionStatus();
    this.props.checkVGFund();
  }
}

  onTextChange = (e, regex) => {
    if(this.props.assetHeld==="assetOutsideVG" && this.props.property === "numberofShares"){
       this.props.updateValue(e.target.value, true);
      }
    let updatedValue = e.target.value.replace(/\s{2,}/g, ' ').replace('. ','');
    if(updatedValue.length === 1){
      updatedValue = updatedValue.replace(/\s{1,}/g, '');
    }
    if (regex.test(updatedValue)) {
      if (this.props.property === "numberofShares") {
        updatedValue = updatedValue.replace(/[^0-9.]/g, "");
      }
        this.setState({currentValue : updatedValue});
    }
    if (this.props.selected && !this.props.isStockSelected) {
      this.props.checkVGFund();
    }
    if(this.props.contribTypeStatus === null)  this.props.updateContributionStatus();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    let placeHolder = "Enter " + this.props.label.toLowerCase();
    if(this.props.property === "numberofShares" && isEdit && !this.props.allShare){
      data = (this.state.currentValue.replace(/[^0-9.]/, "")).replace(/,/g, '').replace(".0000",'');
    }else{
        data = this.state.currentValue;
    }
    const inputId = this.props.accountId.toString() + this.props.assetHeld + this.props.contributionType + this.props.inputId.toString() + this.props.property + 'id';
    return (
      <WrapLabel>
        <InputWrapper>
          <Form.Item
            colon={false}
            label={
              <LabelWrapper>
                {this.props.label}
                {this.props.assetHeld === "assetOutsideVG" &&
                this.props.property === "approxAmount" ? (
                  <TooltipComponent
                    text={
                      "This is the estimated dollar amount of the asset based on the last business day when the market was closed."
                    }
                  />
                ) : (
                  ""
                )}
              </LabelWrapper>
            }
          >
            {getFieldDecorator(
              this.props.accountId.toString() +
                this.props.assetHeld +
                this.props.contributionType +
                this.props.inputId.toString() +
                this.props.property,
              {
                trigger: "onBlur",
                rules:
                  this.props.property === "numberofShares" &&
                  this.props.allShare
                    ? undefined
                    : this.props.label.toLowerCase().indexOf("optional") > 0
                    ? this.state.currentValue.length > 0
                      ? Rules[this.props.property]?.rules
                      : ""
                    : (this.props.assetHeld==="assetOutsideVG" && this.props.property === "numberofShares")?
                    Rules["numberofSharesAssetHeldOutsideVG"]?.rules
                  : Rules[this.props.property]?.rules
              }
            )(
              this.props.property === "numberofShares" &&
                this.props.allShare ? (
                <InputWrapperGraded>
                  <InputWrapper>
                    <div id={inputId}>
                      <InputField
                        placeholder={
                          <PlaceholderWrap>{placeHolder}</PlaceholderWrap>
                        }
                        className="macInputFieldPadding"
                        aria-labelledby={this.props.property}
                        role="textbox"
                        id={this.props.id}
                        disabled
                        value={" "}
                        getPopupContainer={() =>
                          document.getElementById(inputId)
                        }
                      />
                    </div>
                  </InputWrapper>
                </InputWrapperGraded>
              ) : this.props.property !== "approxAmount" ? (
                  <InputWrapper>
                    <InputField
                      placeholder={placeHolder}
                      role="textbox"
                      aria-labelledby={this.props.property}
                      value={data}
                      onFocus={e => this.onFocus(e)}
                      onBlur={this.onFocusOut}
                      id={this.props.id}
                      onChange={e =>
                        this.onTextChange(
                          e,
                          Rules[this.props.property]
                            ? Rules[this.props.property].onchangePattern
                            : /^.*$/
                        )
                      }
                      className={
                        this.props.property === "fundName" ? "cropped-text" : ""
                      }
                    />
                  </InputWrapper>
              ) : (
                <InputWrapper>
                  <InputField
                    className={
                      this.props.shareNumber > 0 &&
                      this.props.unitPrice !== "removed" ? "":"macInputFieldPadding"}
                    role="textbox"
                    placeholder = { this.props.unitPrice ==="removed" || (this.props.unitPrice ===0 &&this.props.shareNumber>0) ? "Not available" :""}
                    aria-labelledby={this.props.property}
                    value={
      
                      this.props.shareNumber > 0 &&
                      this.props.unitPrice !== "removed"
                        ? this.props.shareNumber>0 && this.props.unitPrice > 0 ?l10nUSD.format(
                            this.props.shareNumber * this.props.unitPrice
                          ):""
                        : (this.props.shareNumber?.toString() ==="NaN" || this.props.shareNumber===0) && this.props.unitPrice !== "removed"? "$0.00" : ""
                    }
                    onFocus={e => this.onFocus(e)}
                    onBlur={this.onFocusOut}
                    id={this.props.id}
                    disabled
                  />
                  {this.props.property === "approxAmount" &&
                  this.props.unitPrice>0 ? (
                    <InfoMessage>
                      {this.props.selTicker} closing price as of {this.props.selDate} is ${this.props.unitPrice}/share
                    </InfoMessage>
                  ) : (
                    ""
                  )}
                </InputWrapper>
              )
            )}
          </Form.Item>
        </InputWrapper>
      </WrapLabel>
    );
  }
  
}

const WrappedFundDetails = Form.create({ name: "select" })(FundDetails);

WrappedFundDetails.propTypes = {
  value: PropTypes.string,
  isAutoFilled: PropTypes.string,
  isCleared: PropTypes.bool,
  isStockSelected: PropTypes.bool,
  contribTypeStatus: PropTypes.bool,
  showErrorMessage: PropTypes.object,
  fundInfo: PropTypes.string,
  accountInfo: PropTypes.string,
  isSecuritySelected: PropTypes.bool,
  isDummyUpdated: PropTypes.bool,

  updateValue: PropTypes.func,
checkVGFund: PropTypes.func,
updateValueJson: PropTypes.func,
  updateContributionStatus: PropTypes.func,
  updateAutoFilledStatus: PropTypes.func,
  updateErrorMessages: PropTypes.func

}

const mapStateToProps = (state, ownProps) => {
  return {
    value: state.getIn([
      "makeAContribution",
      "contributionTypes",
      `${ownProps.assetHeld}`,
      `${ownProps.contributionType}`,
      `${ownProps.accountId}`,
      `${ownProps.fundType}`,
      `${ownProps.inputId}`,
      `${ownProps.property}`
    ]),
    isAutoFilled: state.getIn(["makeAContribution","contributionTypes", `${ownProps.assetHeld}`,
    `${ownProps.contributionType}`,
    `${ownProps.accountId}`,
    `${ownProps.fundType}`,
    `${ownProps.inputId}`,"isAutoFilled"]),
    isCleared: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'isCleared']),
    isStockSelected: state.getIn(['makeAContribution','contributionTypes','stockCertificate','stockSelected']),
    contribTypeStatus: state.getIn(['makeAContribution','contributionStatus', 'data', `${ownProps.assetHeld}`]),
    showErrorMessage: state.getIn(["makeAContribution","contributionTypes",'showErrorMessage']),
    fundInfo: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`, `${ownProps.contributionType}`, `${ownProps.accountId}`,`${ownProps.fundType}`]),
    accountInfo: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`, `${ownProps.contributionType}`]),
    isSecuritySelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'sgSelected']),
    isDummyUpdated: state.getIn(["makeAContribution", "contributionTypes", "dummyUpdate"])
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  let currentProperty = ownProps.property;
  let inputId = ownProps.inputId;
  let accountId = ownProps.accountId;
  let fundType = ownProps.fundType;
  return {
    updateValue:  (e, shareChangeFlag) =>
      dispatch(
        changeFundDetails({
          value: e,
          property: currentProperty,
          inputId: inputId,
          accountId: accountId,
          fundType: fundType,
          contributionType: ownProps.contributionType,
          assetHeld: ownProps.assetHeld,
          shareChangeFlag: shareChangeFlag
        })
      ),
    checkVGFund: e =>
      dispatch(
        checkVGMutualFund({
          value: true,
          property: ownProps.selected,
          assetHeld: ownProps.assetHeld
        })
      ),
    updateValueJson: (e, property) =>
      dispatch(
        changeFundDetails({
          value: e,
          property: property,
          inputId: inputId,
          accountId: accountId,
          fundType: fundType,
          contributionType: ownProps.contributionType,
          assetHeld: ownProps.assetHeld
        })
      ),
      updateContributionStatus: () => dispatch(updateContributionStatus({value:false,assetHeld: ownProps.assetHeld})),
      updateAutoFilledStatus: () => dispatch(updateAutoFilledStatus({
        property: currentProperty,
        inputId: inputId,
        accountId: accountId,
        fundType: fundType,
        contributionType: ownProps.contributionType,
        assetHeld: ownProps.assetHeld})),
      updateErrorMessages: data => dispatch(updateErrorMessage(data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WrappedFundDetails)
);
